module.exports = __webpack_public_path__ + "img/EARLY_SUPPORTER.94940f3a.svg";